import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


// Change interface if we will receive more/different fields in the response
interface IReCaptchaResponse {
    success: boolean
}

@Injectable({
    providedIn: 'root'
})

export class ReCaptchaService {

    reCaptchaSiteKey = '6LdbeawZAAAAAEv_kKWEJa68huTOc05uXx5bARTi';
    reCaptchaMissingErrorMessage = 'Invalid captcha!';

    constructor(private http: HttpClient) { }

    getSiteKey(): string {
        return this.reCaptchaSiteKey;
    }

    addRecaptchaToForm(group: FormGroup, fb: FormBuilder) {
        group.addControl('recaptcha', fb.control('', Validators.required));
    }

    getCaptchaMissingErrorMessage(): string {
        return this.reCaptchaMissingErrorMessage;
    }

    // This method is needed if the captcha validation is to be
    // orchestrated in the frontend. Else the server can do the
    // validation and submit the form.
    async isReCaptchaValid(reCaptchaValue): Promise<any> {
        if (!reCaptchaValue) return false;

        try {
            const url = '/Home/ValidateCaptcha';
            const validationResponse = await this.http
                .post<IReCaptchaResponse>(url, { reCaptchaValue }, { responseType: 'json' })
                .toPromise();

            if (!validationResponse || !validationResponse.success) return false;
            return true;
        } catch (error) {
            // add log here if required
            return false;
        }
    }

}